import { useTheme } from 'vuetify';
import { CurrentThemeName } from '~/composables';

export function useCurrentTheme() {
    const useThemeObj = useTheme();
    const currentThemeName = CurrentThemeName();
    const themeIsDark = computed<boolean>(() => useThemeObj.current.value.dark);

    return {
        themePreference: currentThemeName,
        themeName: useThemeObj.name,
        themeClass: useThemeObj.themeClasses,
        themeIsDark
    };
}
